<template>
	<div>
		<a-modal v-show='!ishand' id='supplylist1' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			:dialog-style="{ top: (25 - (form.otherSystemManagementLogList.length*5>20?20:form.otherSystemManagementLogList.length*5))+'vh' }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div v-html='items?"編&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;輯":"添&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;font-size: 0.9rem;">
					
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item prop='supplier' >
									<div slot='label' v-html='"公司名稱"'
									 style="display: inline-block;color: #000000;"></div>
									<!-- <a-input v-model="form.supplier" style='width: 30.5rem;height: 35px !important;'/> -->
									<Situationall v-model="form.supplier" :url='$api.getparas' ref='seachope'
										:params='{"type":"systemservicesupplier"}' 
										:placeholder="''"
										style="width:99%"
										:valstr='form.supplier1'>
									</Situationall>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='聯絡名稱' prop='name'>
									<a-input v-model="form.name" class='warp_width' style="width:99%"  />
								</a-form-model-item>
							</a-col>

						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='電話號碼' prop='phone'>
									<a-input v-model="form.phone"  @change="form.phone = form.phone.replace(/[^0-9]+/g, '')" class='warp_width' style="width:99%"  />
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='電子郵箱' prop='email'>
									<a-input v-model="form.email" class='warp_width' style="width:99%" />
								</a-form-model-item>
							</a-col>

						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='系統類別' prop='system_type'>
									<a-select v-model="form.system_type" class='warp_width' >
										<a-select-option v-for="(item,inds) in domainlist" :key="inds+'a'" :value="item.value">
											{{item.text}}
										</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='通知期限' prop='notice_period'>
									<!-- <a-input v-model="form.notice_period" class='warp_width'/> -->
									<Situationall v-model="form.notice_period" :url='$api.getparas' ref='notice_period'
										:params='{"type":"noticeperiod"}' 
										:placeholder="''"
										style="width:100%"
										:valstr='form.notice_period1'>
									</Situationall>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='開始日期' prop='register_date'>
									<a-date-picker
									v-model='form.register_date' placeholder='請選擇開始日期' :disabled-date="disabledDate"/>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='完結日期' prop='expire_date'>
									<a-date-picker
									v-model='form.expire_date' placeholder='請選擇完結日期' :disabled-date="disabledDates" />
								</a-form-model-item>
							</a-col>
						</a-row>

						<div id='lastname'>
							<a-form-model-item label='合約內容' prop='systemservice'>
								<a-input v-model="form.systemservice" class='warp_width' style="width:99%" @input='getdata' />
							</a-form-model-item>
						</div>
						<div id='lastname'>
							<!-- <a-form-model-item prop='supplier'>
								<div slot='label' v-html='"供&nbsp;&nbsp;应&nbsp;商"'
								 style="display: inline-block;color: #000000;"></div>
								<Situationall v-model="form.supplier" :url='$api.getparas' ref='seachope'
									:params='{"type":"systemservicesupplier"}' :style='"width: 30.5rem;height: 35px !important;"' 
									:placeholder="''"
									:valstr='form.supplier1'>
								</Situationall>
							</a-form-model-item> -->
							<a-form-model-item prop='remark'>
								<div slot='label' v-html='"備&emsp;註"'
								 style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.remark" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }"
									style='width: 30.5rem;' />
							</a-form-model-item>
						</div>
					</a-form-model>
					<a-row v-if='form.otherSystemManagementLogList.length'>
						<div class='mydivs'>
							<div v-for='(item,ind) in form.otherSystemManagementLogList' >
								<div class='f'>
									<div style="position: absolute;top: 0;right: 0;">{{item.createtime}}</div>
								</div>
								<div class='c' v-if='item.supplier'>
									<div v-html='"公司名稱 :"' style='display:inline-block;'></div>
									 {{item.supplier}}</div>
								<div class='c' v-if='item.systemservice'>合約內容 : {{item.systemservice}}</div>
								<div class='c' v-if='item.name'>聯絡姓名 : {{item.name}}</div>
								<div class='c' v-if='item.phone'>電話號碼 : {{item.phone}}</div>
								<div class='c' v-if='item.email'>電子郵箱 : {{item.email}}</div>
								<div class='c' v-if='item.system_type'>系統類別 : {{item.system_type}}</div>
								<div class='c' v-if='item.ip'><div v-html='"域&nbsp;&nbsp;名&nbsp;IP&nbsp;:"' style='display:inline-block;'></div> {{item.ip}}</div>
				
								<div class='c' v-if='item.register_date'>註冊日期 : {{item.register_date}}</div>
								<div class='c' v-if='item.expire_date'>到期日期 : {{item.expire_date}}</div>
								<div class='c' v-if='item.notice_period'>通知期限 : {{item.notice_period}}</div>
								<div class='c' v-if='item.remark' style="display:flex;width:80%">
									<div v-html='"備&emsp;註&nbsp;: "' style="display: inline-block;flex-shrink: 0;"></div>
									{{item.remark}}
								</div>
								<div class='t' v-if='ind !== form.otherSystemManagementLogList.length-1'></div>
							</div>
						</div>
					</a-row>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handbect("form")'  v-html='"保&emsp;存"'>保存</button>
						<!-- <button class='btn1 btn2' @click='resetForm("form")'>清除</button> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				domainlist:[
					{value:'軟件系統',text:'軟件系統'},
					{value:'硬件系統',text:'硬件系統'},
				],
				ishand: false,
				fourthqty: '',
				labelCol: {
					span: 8
				},
				wrapperCol: {
					span: 16
				},
				visible: true,
				rules: {
					systemservice:[{required:true,message:' ',trigger:'blur'}],
					register_date:[{required:true,message:' ',trigger:'change'}],
					expire_date:[{required:true,message:' ',trigger:'change'}],
					system_type:[{required:true,message:' ',trigger:'change'}],
					supplier:[{required:true,message:' ',trigger:'blur'}],
					notice_period:[{required:true,message:' ',trigger:'change'}],
					name:[{required:true,message:' ',trigger:'change'}],
					phone:[{required:true,message:' ',trigger:'change'}],
					email:[{required:true,message:' ',trigger:'change'}],
				},
				form: {
					 "systemservice":"", //合約內容
					 "supplier":"",                  //供應商
					 "register_date":"", //註冊日期
					 "expire_date":"",  //到期日期
					 "system_type":"",  //域名類型
					 "remark":"", //備註
					 "notice_period":"", //通知期限
					 "name":"", //聯絡名稱
					 "email":"", //電子郵箱
					 "phone":"", //電話號碼
					 otherSystemManagementLogList:[]
				},
			}
		},
		watch:{
			items:{
				deep:true,
				handler(ev){
				}
			},
		},
		mounted() {
			if(this.items){
				this.handz()
			}
		},
		methods: {
			disabledDate(current) {
				if(this.form.expire_date){
					return current && current > new Date(this.form.expire_date)
				}else{
					return false
				}
			},
			disabledDates(current){
				if(this.form.register_date){
					return current && current < new Date(this.form.register_date)
				}else{
					return false
				}
			},
			getdata() {

			},
			//获取美国 香港当地时间
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.ditodate,
					data: {
						"flag":"systemservice",
						 "systemserviceid":this.items
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						this.form.supplier1 = JSON.parse(JSON.stringify(this.form.supplier))
						this.form.notice_period1 = JSON.parse(JSON.stringify(this.form.notice_period))
						this.form.register_date = res.data.register_date.split('/').reverse().join('-')
						this.form.expire_date = res.data.expire_date.split('/').reverse().join('-')
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				 this.$refs[ruleForm].validate(valid => {
				        if (valid) {
							this.form.register_date = this.form.register_date._d ? App.oDate.secsTime3(this.form.register_date._d) : this.form.register_date;
							this.form.expire_date = this.form.expire_date._d ? App.oDate.secsTime3(this.form.expire_date._d) : this.form.expire_date;
							this.form.token = this.$store.state.token;
							this.form.flag = "systemservice";
							this.$ajax({
								method: 'post',
								url: this.$api.newOther,
								data: this.form
							}).then(res => {
								if (res.data.qmiscode === 1000) {
									App.oTool.successT();
									this.$emit('child', 1)
								} else {
									App.oTool.warningT(res.data.qmismsg);
								}
							})
				        } else {
				          console.log('error submit!!');
				          return false;
				        }
				      });
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style lang="scss">
	#supplylist1 .ant-modal-header,
	#supplylist1 .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#supplylist1 {
		.ant-form-explain{
			display: none;
		}
		.ant-modal {
			top: 25vh;
		}

		.ant-col-12 {
			text-align: right;
		}

		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		#lastname>div{
			// justify-content: flex-end;
			text-align: right;
			}
		#lastname{
			.ant-form-item-label{
				width: 10%;
			}
			.ant-form-item-control-wrapper{
				width: 86%;
				    // left: .3rem;
				    position: relative;
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .75rem !important;
		}

		.ant-input {
			font-size: .75rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .75rem !important;
		}

		.ant-form-item-children {
			font-size: .75rem !important;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
		
			.c {
				font-size: .75rem;
				margin: .2rem 0;
			}
		
			.f {
				// display: flex;
				// justify-content: space-between;
				position: relative;
				right: 0;
				top: 0;
			}
		
			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
